import { z } from 'zod';

export const getSalesPersonTypesSchema = z.array(
  z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
    BOID: z.string().optional(),
    isFromManager: z.boolean(),
    isActive: z.boolean(),
  })
);

export type GetSalesPersonTypesResponse = z.infer<typeof getSalesPersonTypesSchema>;
